import { cn } from "@/lib/utils";

/**
 * Circular rank indicator used in the interactions table (screenshot 2).
 * A small coloured dot attached to the number encodes the lab-priority band:
 *   green  = ≥60/100
 *   amber  = 40–59
 *   grey   = <40
 */
export function RankCircle({ rank, priority }: { rank: number; priority?: number }) {
  const band = (priority ?? 0) >= 0.6 ? "high" : (priority ?? 0) >= 0.4 ? "mid" : "low";
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="grid h-6 w-6 place-items-center rounded-full border border-border bg-background font-mono text-[11px] font-semibold tabular-nums">
        {rank}
      </span>
      <span
        className={cn(
          "priority-dot",
          band === "high" && "bg-priority-high",
          band === "mid" && "bg-priority-mid",
          band === "low" && "bg-priority-low",
        )}
        aria-hidden
      />
    </span>
  );
}
